module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a7ca2f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1496
// module chunks = 0